/**
 * @generated SignedSource<<dfd526c77ffb0069520b90cecf70204f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionDescription_routine$data = {
  readonly description: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly __typename: "Image";
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionDescriptionContent_Routine">;
  readonly " $fragmentType": "WorkspaceRoutineOccasionDescription_routine";
};
export type WorkspaceRoutineOccasionDescription_routine$key = {
  readonly " $data"?: WorkspaceRoutineOccasionDescription_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionDescription_routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineOccasionDescription_routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionDescriptionContent_Routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "232de8b27cbf001f9e2ffa0e2a264bf0";

export default node;
